import React, {useState} from 'react';
import {Package, MapPin, Truck, Bike, ArrowRight} from 'lucide-react';

export default function Hero() {
    const [tracked, setTracked] = useState(false);
    const [trackingInput, setTrackingInput] = useState('');

    const handleTrack = () => {
        if (trackingInput.trim()) setTracked(true);
    };

    return (
        // <section id="home" className="relative overflow-hidden pt-0" style={{ height: '100vh' }}>
        <section id="home" className="relative overflow-hidden pt-0">

            {/* yellow accent bar */}
            {/*<div className="absolute top-0 left-0 right-0 h-1 bg-dh-yellow z-[1001]"/>*/}

            {/* hero wrapper */}
            {/*<div className="flex items-center bg-white" style={{ height: 'calc(100vh - 65px)', marginTop: '65px' }}>*/}
            <div className="flex items-center bg-white pt-1">
                <div className="hero-wrapper relative w-full bg-dh-blue">

                    {/* truck image */}
                    <img
                        src="/assets/truck.jpg"
                        alt="Delivery Hub Truck"
                        className="hero-truck absolute inset-0 w-full h-full object-cover object-center"
                    />

                    {/* gradient overlay */}
                    <div className="hero-gradient absolute inset-0" style={{
                        background: 'linear-gradient(110deg, rgba(10,74,190,0.92) 10%, rgba(10,74,190,0.80) 50%, rgba(10,74,190,0.30) 70%, rgba(10,74,190,0.0) 90%)',
                    }}/>

                    {/* content */}
                    <div className="relative z-[2] w-full">
                        <div className="dh-container hero-inner relative w-full flex items-center">
                            <div className="grid lg-custom:grid-cols-2 grid-cols-1 gap-[5vh] items-end w-full lg-custom:py-10 pt-10 pb-6">
                                <div className="hero-text">
                                    <div className="inline-flex items-center gap-2 rounded-full px-[14px] py-[6px] mb-5 border"
                                         style={{ background: 'rgba(249,216,0,0.15)', borderColor: 'rgba(249,216,0,0.3)' }}>
                                        <div className="w-[7px] h-[7px] rounded-full bg-dh-yellow"/>
                                        <div className="text-dh-yellow text-[13px] font-medium tracking-[0.5px]"
                                             style={{ fontFamily: "'Inter'" }}>
                                            Reaching Every Corner of Lebanon
                                        </div>
                                    </div>

                                    <h1 className="text-white mb-[18px] leading-[0.9] tracking-[0.01em]"
                                        style={{
                                            fontFamily: "'Bebas Neue', sans-serif",
                                            fontWeight: 900,
                                            fontSize: 'clamp(5rem, 11vw, 10rem)',
                                        }}>
                                        your<br/>logistics<br/><span className="text-dh-yellow">backbone.</span>
                                    </h1>

                                    <p className="text-[1.7vh] font-light leading-[1.65] mb-8 max-w-[400px]"
                                       style={{ color: 'rgba(255,255,255,0.8)', fontFamily: "'Inter'" }}>
                                        Domestic delivery, warehousing & full fulfillment — built for businesses that can't afford delays.
                                    </p>

                                    <div className="flex gap-3 flex-wrap">
                                        <a href="#contact"
                                           className="inline-block px-[26px] py-[13px] rounded-[10px] font-bold text-[15px] text-dh-blue bg-dh-yellow transition-transform duration-150"
                                           style={{ fontFamily: "'Inter'" }}
                                           onMouseEnter={e => {
                                               e.target.style.transform = 'translateY(-2px)';
                                               e.target.style.boxShadow = '0 8px 24px rgba(249,216,0,0.4)';
                                           }}
                                           onMouseLeave={e => {
                                               e.target.style.transform = 'none';
                                               e.target.style.boxShadow = 'none';
                                           }}
                                        >Get a Quote</a>
                                        <a href="#services"
                                           className="inline-block px-[26px] py-[13px] rounded-[10px] text-[15px] text-white border border-white/30 transition-colors duration-200"
                                           style={{ background: 'rgba(255,255,255,0.1)', fontFamily: "'Inter'" }}
                                           onMouseEnter={e => e.target.style.background = 'rgba(255,255,255,0.18)'}
                                           onMouseLeave={e => e.target.style.background = 'rgba(255,255,255,0.1)'}
                                        >Our Services</a>
                                    </div>
                                </div>

                                <div
                                    className="hero-actions bg-white/95 backdrop-blur-md rounded-lg p-[15px] shadow-[0_8px_40px_rgba(0,0,0,0.18)] flex flex-col gap-2.5">

                                    <div className="flex flex-col gap-3">

                                        {/* error banner */}
                                        {tracked && (
                                            <div className="flex items-start gap-3 px-4 py-3 rounded-md border"
                                                 style={{ background: '#fff5f5', borderColor: '#c0392b', borderLeft: '4px solid #c0392b' }}>
                                                <span style={{ color: '#c0392b', fontSize: '16px' }}>⚠</span>
                                                <div className="flex-1">
                                                    <p className="text-[13px] font-bold m-0" style={{ color: '#c0392b', fontFamily: "'Inter'" }}>
                                                        Invalid tracking number
                                                    </p>
                                                    <p className="text-[12px] m-0 mt-0.5" style={{ color: '#7b241c', fontFamily: "'Inter'" }}>
                                                        This tracking number may be invalid or not active yet. Please check with the sender.
                                                    </p>
                                                </div>
                                                <button onClick={() => setTracked(false)} style={{
                                                    color: '#c0392b',
                                                    background: 'none',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    fontSize: '16px'
                                                }}>∧
                                                </button>
                                            </div>
                                        )}

                                        {/* tracking input */}
                                        <div>
                                            <div className="flex items-center gap-3 shrink-0 mb-1.5">
                                                <div className="text-[13px] font-semibold whitespace-nowrap"
                                                     style={{ fontFamily: "'Inter'", color: '#0d0d0d' }}>
                                                    Track Your Package
                                                </div>
                                            </div>
                                            <div className="flex items-stretch gap-3">
                                                <input
                                                    type="text"
                                                    placeholder="Enter Your Tracking Number"
                                                    value={trackingInput}
                                                    onChange={e => setTrackingInput(e.target.value)}
                                                    className="flex-1 px-4 py-1.5 rounded-md text-[13px] outline-none"
                                                    style={{
                                                        border: `1px solid ${tracked ? '#c0392b' : '#e0dfd6'}`,
                                                        fontFamily: "'Inter'",
                                                        color: tracked ? '#c0392b' : '#0d0d0d',
                                                        background: '#ffffff',
                                                    }}
                                                />
                                                <button
                                                    onClick={handleTrack}
                                                    className="px-5 py-1.5 rounded-md font-bold text-[14px] text-white bg-dh-blue shrink-0 flex items-center gap-1 transition-transform duration-150 hover:-translate-y-0.5"
                                                    style={{ fontFamily: "'Inter'" }}
                                                >
                                                    Track <ArrowRight size={14}/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <p className="hero-call text-[11px] text-center mt-1 leading-[1.5]"
                                       style={{ fontFamily: "'Inter'", color: '#9e9d95' }}>
                                        Need help? Call us at{' '}
                                        <a href="tel:+96176799990" className="font-medium no-underline" style={{ color: '#0a4abe' }}>
                                            +961 76 799 990
                                        </a>
                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
        @media (max-width: 900px) {
          .hero-truck { display: none !important; }
          .hero-gradient { display: none !important; }
          .hero-inner { grid-template-columns: 1fr !important; }
          .hero-actions a[href] { background: #f8f8f6 !important; border: 1px solid #e0dfd6 !important; padding: 10px !important; }
          .hero-actions a[href] p:first-child { color: #0d0d0d !important; }
          .hero-actions a[href] p:last-child { color: #9e9d95 !important; }
          .hero-actions > p { color: #9e9d95 !important; }
          .hero-actions .action-icon { display: none !important; }
          .hero-call a { color: #0a4abe !important; border: none !important; text-decoration: none !important; }
          .hero-call { color: #9e9d95 !important; }
          .hero-wrapper { padding-bottom: 32px; }
        }
      `}</style>
        </section>
    );
}